import { createSlice } from '@reduxjs/toolkit';
import { findSelectShape, searchSelectShape, getSelectShape } from './api';
import { initialState } from './api/interface';

const selectShapeSlice = createSlice({
  name: 'selectShape',
  initialState,
  reducers: {
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
    },
    setHasMore: (state, action) => {
      state.hasMore = action.payload.hasMore;
      state.status = 'idle';
    },

    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findSelectShape.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findSelectShape.fulfilled, (state, action) => {
      state.data.push(...action.payload.data);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
      state.hasMore = action.payload.data.length < 10 ? false : true;
    });
    builder.addCase(findSelectShape.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(searchSelectShape.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(searchSelectShape.fulfilled, (state, action) => {
      state.data = [...action.payload.data, ...state.data];
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
    });
    builder.addCase(searchSelectShape.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(getSelectShape.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSelectShape.fulfilled, (state, _) => {
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getSelectShape.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setSkip, setHasMore, setStatus, reset } =
  selectShapeSlice.actions;
export default selectShapeSlice.reducer;
